/* ============================================================
   BOTANILABS — Cart PAGE behaviour (secondary to the drawer).
   Drives the page's gram stepper / remove / next-tier bump through the real
   cart API and re-renders ITS OWN section in place — it never opens the drawer.
   Shares the line markup (snippets/botani-cart-line.liquid) and the gift bar
   (botani-cart.js renderGifts) with the drawer. Same serial-FIFO + debounce
   anti-429 discipline as the drawer. Scoped to [data-botani-cart-page].
   ============================================================ */
(function () {
  function root() { return document.querySelector('[data-botani-cart-page]'); }
  function sectionId() { var r = root(); return r ? r.getAttribute('data-section-id') : null; }
  function refreshGifts() {
    if (window.BotaniCart && typeof window.BotaniCart.refreshGifts === 'function') window.BotaniCart.refreshGifts();
  }
  function busy(on) { var r = root(); if (r) r.classList.toggle('botani-loading', !!on); }

  var updating = false, queue = [], pendingQty = {};
  var DEBOUNCE_MS = 200;

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      if (r.status === 429) { var e = new Error('cart-rate-limited-429'); e.code = 429; throw e; }
      return r.json();
    });
  }

  function doChange(line, quantity) {
    var url = (window.routes && window.routes.cart_change_url) || '/cart/change.js';
    var sid = sectionId();
    var sections = sid ? [sid, 'cart-icon-bubble'] : ['cart-icon-bubble'];
    return post(url, { line: line, quantity: quantity, sections: sections, sections_url: window.location.pathname });
  }

  function render(state) {
    if (!state) { document.location.reload(); return; }
    var sid = sectionId();
    if (state.sections && sid && state.sections[sid]) {
      var doc = new DOMParser().parseFromString(state.sections[sid], 'text/html');
      var src = doc.querySelector('[data-botani-cart-page]');
      var dst = root();
      if (src && dst) dst.innerHTML = src.innerHTML;
    }
    if (state.sections && state.sections['cart-icon-bubble']) {
      var bdoc = new DOMParser().parseFromString(state.sections['cart-icon-bubble'], 'text/html');
      var bsrc = bdoc.querySelector('#cart-icon-bubble') || bdoc.querySelector('.shopify-section') || bdoc.body;
      var bdst = document.getElementById('cart-icon-bubble');
      if (bsrc && bdst) bdst.innerHTML = bsrc.innerHTML;
    }
    refreshGifts();
  }

  function drain() {
    if (!queue.length) { updating = false; busy(false); return; }
    updating = true; busy(true);
    var op = queue.shift();
    Promise.resolve().then(op)
      .then(function (state) { render(state); })
      .catch(function (e) { console.error('[botani-cart-page]', e && e.message ? e.message : e); })
      .finally(function () { drain(); });
  }
  function enqueue(op) { queue.push(op); if (!updating) drain(); }

  function changeLine(line, quantity, immediate) {
    var ex = pendingQty[line];
    if (ex && ex.timer) clearTimeout(ex.timer);
    if (immediate) {
      delete pendingQty[line];
      enqueue(function () { return doChange(line, quantity); });
      return;
    }
    pendingQty[line] = {
      quantity: quantity,
      timer: setTimeout(function () {
        var q = pendingQty[line].quantity; delete pendingQty[line];
        enqueue(function () { return doChange(line, q); });
      }, DEBOUNCE_MS),
    };
    busy(true);
  }

  function setLineQty(line, qty) {
    var item = document.querySelector('[data-botani-cart-page] .botani-item[data-line="' + line + '"]');
    if (!item) return;
    var val = item.querySelector('.botani-stepper__val');
    var unit = item.getAttribute('data-unit');
    if (val) val.innerHTML = qty + (unit ? '<small>' + unit + '</small>' : '');
    var btns = item.querySelectorAll('[data-cart-plus],[data-cart-minus]');
    Array.prototype.forEach.call(btns, function (b) { b.setAttribute('data-qty', qty); });
  }
  function fadeOut(line) {
    var item = document.querySelector('[data-botani-cart-page] .botani-item[data-line="' + line + '"]');
    if (item) { item.style.opacity = '0.35'; item.style.pointerEvents = 'none'; }
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-botani-cart-page]')) return;
    var minus = e.target.closest('[data-cart-minus]');
    var plus = e.target.closest('[data-cart-plus]');
    var remove = e.target.closest('[data-cart-remove]');
    var bump = e.target.closest('[data-cart-bump]');

    if (minus) {
      var lm = parseInt(minus.getAttribute('data-line'), 10);
      var bm = pendingQty[lm] ? pendingQty[lm].quantity : (parseInt(minus.getAttribute('data-qty'), 10) || 1);
      var nm = Math.max(1, bm - 1);
      setLineQty(lm, nm); changeLine(lm, nm);
    } else if (plus) {
      var lp = parseInt(plus.getAttribute('data-line'), 10);
      var bp = pendingQty[lp] ? pendingQty[lp].quantity : (parseInt(plus.getAttribute('data-qty'), 10) || 1);
      var np = bp + 1;
      setLineQty(lp, np); changeLine(lp, np);
    } else if (remove) {
      var lr = parseInt(remove.getAttribute('data-line'), 10);
      fadeOut(lr); changeLine(lr, 0, true);
    } else if (bump) {
      var lb = parseInt(bump.getAttribute('data-line'), 10);
      var tb = parseInt(bump.getAttribute('data-target'), 10);
      setLineQty(lb, tb); changeLine(lb, tb, true);
    }
  });
})();
